import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module table/tablecellwidth/tablecellwidthediting
 */
import { Plugin } from 'ckeditor5/src/core.js';
import TableEditing from './../tableediting.js';
import TableCellWidthCommand from './commands/tablecellwidthcommand.js';
import { getNormalizedDefaultProperties } from '../utils/table-properties.js';
import { enableProperty } from '../utils/common.js';
/**
 * The table cell width editing feature.
 *
 * Introduces `tableCellWidth` table cell model attribute alongside with its converters
 * and a command.
 */
var TableCellWidthEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(TableCellWidthEditing, _Plugin);
  var _super = _createSuper(TableCellWidthEditing);
  function TableCellWidthEditing() {
    _classCallCheck(this, TableCellWidthEditing);
    return _super.apply(this, arguments);
  }
  _createClass(TableCellWidthEditing, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var editor = this.editor;
      var defaultTableCellProperties = getNormalizedDefaultProperties(editor.config.get('table.tableCellProperties.defaultProperties'));
      enableProperty(editor.model.schema, editor.conversion, {
        modelAttribute: 'tableCellWidth',
        styleName: 'width',
        defaultValue: defaultTableCellProperties.width
      });
      editor.commands.add('tableCellWidth', new TableCellWidthCommand(editor, defaultTableCellProperties.width));
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'TableCellWidthEditing';
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "requires",
    get: function get() {
      return [TableEditing];
    }
  }]);
  return TableCellWidthEditing;
}(Plugin);
export { TableCellWidthEditing as default };